const mutations = {
  mutationRenewal(state, payload) {
    state.renewal = payload;
  },

  mutationRenewals(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.renewals[payload.tab] = payload.responseData;
    } else {
      state.renewals = payload;
    }
  },

  mutationRenewalsMeta(state, payload) {
    state.renewalsMeta = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },
};

export default mutations;
